import React from 'react';
import  Iconify  from './index';

export default function CountryFlag({ code, width = 24,height=18, style, ...props }) {
    if (!code) return null;

    return (
        <Iconify
            icon={`flag:${code.toLowerCase()}-4x3`}
            width={width}
            height={height}
            style={{
                marginRight: 12,
                verticalAlign: "middle",
                borderRadius: "2px",
                // boxShadow: "0 0 1px rgba(0,0,0,0.3)",
                ...style,
            }}
            {...props}
        />
    );
}
